'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggle = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _deep = require('helpers/deep');

var _object = require('helpers/object');

var ObjectUtil = _interopRequireWildcard(_object);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toggle = exports.Toggle = function Toggle() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react2.default.createElement(
    'label',
    { className: 'media' },
    _react2.default.createElement('input', (0, _extends3.default)({}, ObjectUtil.omit(['value'], props.input), {
      checked: (0, _deep.deepExtract)('input.value', props) ? 'checked' : '',
      className: 'media__img',
      type: 'checkbox'
    })),
    _react2.default.createElement(
      'span',
      { className: 'media__body' },
      props.label
    )
  );
};

Toggle.propTypes = {
  input: _propTypes2.default.object,
  label: _propTypes2.default.node
};